const RootPath = window.g.baseUrl
const apis = {
  /* 外协商管理 api */
  getOutsourceCompanyList: RootPath + 'plugin/outsource/outsourcecompany/GetOutsourceCompanyList',
  delOutsourceCompanyList: RootPath + 'plugin/outsource/outsourcecompany/DelOutsourceCompanyList',
  getOutsourceCompanyForm: RootPath + 'plugin/outsource/outsourcecompany/GetOutsourceCompanyForm',
  saveOutsourceForm: RootPath + 'plugin/outsource/outsourcecompany/SaveOutsourceForm',

  /* 外协单 api */
  getOutsourceOrderList: RootPath + 'plugin/outsource/outsourceorder/GetOutsourceOrderList',
  delOutsourceOrderList: RootPath + 'plugin/outsource/outsourceorder/DelOutsourceOrderList',
  getOrderCompany: RootPath + 'plugin/outsource/outsourceorder/GetOrderCompany',
  getOutsourceOrderForm: RootPath + 'plugin/outsource/outsourceorder/GetOutsourceOrderForm',
  saveOutsourceOrderForm: RootPath + 'plugin/outsource/outsourceorder/SaveOutsourceOrderForm',
  getProductAttach: RootPath + 'plugin/outsource/outsourceorder/GetProductAttach',
  saveOutsourceOrderDetail: RootPath + 'plugin/outsource/outsourceorder/SaveOutsourceOrderDetail',
  delOutsourceOrderDetail: RootPath + 'plugin/outsource/outsourceorder/DelOutsourceOrderDetail',
  saveBatchOutsourceOrderDetail: RootPath + 'plugin/outsource/outsourceorder/SaveBatchOutsourceOrderDetail',
  getProductCount: RootPath + 'plugin/outsource/outsourceorder/GetProductCount'
}

export default apis
